var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"logo",attrs:{"data-track-text":"logo.sanitas","href":_vm.logoHref}},[_c('img',{attrs:{"src":_vm.logo,"width":"124px","height":"30px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }